import { IRelativeDate } from '@pushly/aqe/lib/interfaces/index'
import { RelativeDateDisplayMetric } from '@pushly/aqe/lib/enums/index'

export const JOURNEY_DEFAULT_ABANDONMENT_SECONDS = 3600
export const JOURNEY_DEFAULT_ABANDONMENT_METRIC = 'hours'
export const JOURNEY_ABANDONED_BROWSE_DEFAULT_ITEM_VIEWS = 1
export const JOURNEY_ABANDONED_BROWSE_MINIMUM_ITEM_VIEWS = 1
export const JOURNEY_ABANDONED_BROWSE_MAXIMUM_ITEM_VIEWS = 20

export const JOURNEY_DEFAULT_ABANDONED_CART_COOLDOWN_PERIOD: IRelativeDate = {
    interval_seconds: 86400,
    display_metric: RelativeDateDisplayMetric.DAYS,
}
